import api from 'api/apiInstance';

export function clientDocumentVaultItemMarkAsSeenApi(path: string) {
  return {
    path,
    PATCH: () => api.patch(path),
  };
}
